export default __webpack_public_path__ + "static/media/GraphikRegular.03e2ce86.woff2";